import styles from '../select.module.css';

import React from 'react';
import PropTypes from 'prop-types';
import SelectOption from '../SelectOption';

const SelectDropdown = ({
  filteredOptions,
  handleOptionClick,
  selectedValues,
  valueKey,
  titleKey,
  multiple,
  renderOption,
  position,
}) => {
  // Проверка выбрана ли опция
  const isOptionSelected = (optionValue) => {
    return selectedValues.includes(optionValue);
  };

  // Отрисовка компонента "Ничего не найдено"
  const renderNoResults = () => {
    return <div className={styles.noResults}>Ничего не найдено</div>;
  };

  return (
    <div
      className={styles.dropdown}
      style={{ top: `${position.top}px`, left: `${position.left}px`, width: `${position.width}px` }}
    >
      {filteredOptions.length === 0 ? (
        renderNoResults()
      ) : (
        <div className={styles.optionsList}>
          {filteredOptions.map((option) => (
            <SelectOption
              key={option[valueKey]}
              option={option}
              isSelected={isOptionSelected(option[valueKey])}
              onClick={() => handleOptionClick(option[valueKey])}
              titleKey={titleKey}
              multiple={multiple}
              renderOption={renderOption}
            />
          ))}
        </div>
      )}
    </div>
  );
};

SelectDropdown.propTypes = {
  filteredOptions: PropTypes.array.isRequired,
  handleOptionClick: PropTypes.func.isRequired,
  selectedValues: PropTypes.array.isRequired,
  valueKey: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  multiple: PropTypes.bool.isRequired,
  renderOption: PropTypes.func,
};

export default SelectDropdown;
